var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5348 24.5704C19.3279 24.9933 24.367 20.6399 24.7899 14.8468C25.2128 9.05369 20.8594 4.01459 15.0663 3.59168C9.27315 3.16876 4.23407 7.52219 3.81115 13.3153C3.38824 19.1084 7.74166 24.1475 13.5348 24.5704Z",
    stroke: "#054D94",
    strokeOpacity: 0.2,
    strokeWidth: 7.01153
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.1d8fc8f00322a5b084072caaf7e6cb92.svg";
export { ForwardRef as ReactComponent };